export default {
  name: "MinusCircleSolid",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M16 2C8.28 2 2 8.28 2 16s6.28 14 14 14 14-6.28 14-14S23.72 2 16 2zm6.5 15.5h-13a1.5 1.5 0 1 1 0-3h13a1.5 1.5 0 1 1 0 3z",
  },
}
